export default class Column {
  constructor(data, parentVM, node, options) {
    let self = this;
    this.defaults = {
      properties: {
        hideable: { enabled: false },
        sortable: { enabled: false },
        editable: { enabled: false }
      }
    };
    this.config = _.extend({}, this.defaults.properties, options);
    this.parentVM = parentVM;
    this.width = _.isUndefined(data.width) ? '' : data.width;
    this.hideable = _.isUndefined(data.hideable) ? true : data.hideable;
    this.name = _.isUndefined(data.name) ? s.titleize(s.humanize(data.property)) : data.name;

    if(this.config.hideable.enabled) {
      this.visible = ko.observable(false);
      this.visible.subscribe(function(){
        self.parentVM.visibleColsChanged(true);
      });
    }
    if(this.config.editable.enabled) {
      this.mapInitialEditingOptions(data);
      this.datepickerOptions = {
        autoclose: true,
        orientation: 'bottom'
      };
    }
    _.extend(this, data);
  }

  mapInitialEditingOptions(col) {
    let self = this;
    if(!_.isUndefined(col.editable)) {
      col.editable.editing = ko.observable(false);
      if(col.editable.type == 'dropdown' && !_.isUndefined(col.editable.dropdown_options)){
        let dropDownKeys = ko.mapping.toJS(col.editable.dropdown_options);
        col.editable.dropdown_options = _.map(dropDownKeys, function(opt) { return s.titleize(opt); });
      }

      col.editable.editing.subscribeChanged(function(newValue, oldValue){
        if(newValue !== oldValue){
          self.parentVM.lastChangedCol(self.property);
        }
      });
    }
  }

  setEditingFunction(column, row) {
    if(column.editable.type == 'text'){
      column.toggleInlineEditing(column, row);
    } else if(column.editable.type == 'date'){
      column.toggleDateEditing(column, row);
    } else if(column.editable.type == 'dropdown' && !_.isUndefined(column.editable.dropdown_options)){
      column.toggleInlineDropdown(column, row);
    } else if(column.editable.type == 'complex_number'){
      column.toggleInlineComplexWeightEditing(column, row);
    }
  }

  toggleInlineEditing(column, row) {
    if(!column.editable.editing() && !row.editing()) {
      this.resetInlineEditingOptions();
      this.parentVM.editingType('text');
      this.enableInlineEditing(column, row);
    }
  }

  toggleDateEditing(column, row) {
    if(!column.editable.editing() && !row.editing()) {
      column.width == 'date_short' ? this.parentVM.editingType('date_short') : this.parentVM.editingType('date');
      this.enableInlineEditing(column, row);
      // Required for datepickers
      $('#date-editing-field').click();
    }
  }

  toggleInlineDropdown(column, row) {
    let self = this;

    if (!column.editable.editing() && !row.editing()) {
      this.resetInlineEditingOptions();
      this.parentVM.editingType('dropdown');
      this.enableInlineEditing(column, row);

      setTimeout(function() {
        let $selectPicker = $('#inline-dropdown').find('select');

        $selectPicker.on('shown.bs.select', function () {
          self.updateInlineDropdownPosition($('#inline-dropdown'));
        });

        $selectPicker.on('hidden.bs.select', function () {
          self.resetInlineEditingOptions();
        });

        $('#inline-dropdown').find('button').click();
        $('#inline-dropdown').find('a').first().focus();
        $('#inline-dropdown').find('button').attr({'tabindex': '-1'});
      }, 10);
    }
  }

  toggleInlineComplexWeightEditing(column, row) {
    if(!column.editable.editing() && !row.editing()) {
      this.resetInlineEditingOptions();
      this.parentVM.editingType('complex_number');
      this.enableInlineEditing(column, row);
    }
  }

  enableInlineEditing(column, row) {
    column.editable.editing(true);
    row.editing(true);
  }

  resetInlineEditingOptions() {
    let self = this;
    if(!_.isUndefined(self.parentVM)){
      self = this.parentVM;
    }
    _.each(self.rows(), function(row) {
      row.editing(false);
    });
    _.each(self.columns(), function(col) {
      if(!_.isUndefined(col.editable)){
        col.editable.editing(false);
      }
    });
    $('.bootstrap-datetimepicker-widget').remove();
    self.editingType('');
  }

  updateInlineDropdownPosition($filterMenu) {
    let self = this;
    let $btn = $('.dropdown-toggle', $filterMenu);
    let $menu = $('div.dropdown-menu', $filterMenu);
    let $doc = $(document);

    if ($menu.hasClass('open')) {
      setTimeout(function() {
        let offset = $btn.offset();
        let vp = {
          width : window.innerWidth,
          height : window.innerHeight
        };
        let dSize = {
          width: $menu.outerWidth(),
          height: $menu.outerHeight()
        };

        let pos = {};
        // Need to fix for dropup menu
        if (($menu.offset().top + $menu.height()) > (vp.height + $(window).scrollTop())){
          pos = {
            top: offset.top - $doc.scrollTop() + 53,
            left: offset.left - $doc.scrollLeft() - 5
          };
        } else {
          pos = {
            top: offset.top - $doc.scrollTop() + 3,
            left: offset.left - $doc.scrollLeft() - 5
          };
        }

        let leftOffset = (pos.left + dSize.width >= vp.width ) ? (dSize.width - $btn.width()) : 0;
        let topOffset = (pos.top + dSize.height >= vp.height ) ? (dSize.height + $btn.height() ) : 0;

        let newTop = (pos.top - topOffset);
        let newLeft = (pos.left - leftOffset);

        $menu.css({'position':'fixed','top':newTop, 'left': newLeft });
        self.updateInlineDropdownPosition($filterMenu);
      }, 10);
    }
  }

  columnWidthClass() {
    let className = 'kd-data-table__column';

    if(!_.isEmpty(this.width))
      className += '-' + this.width;

    if(!_.isUndefined(this.editable))
      className += ' editable';

    return className;
  }

  editingEnabledClass(col, row) {
    let self = col;
    return ko.pureComputed(function(){
      if(row.editing() && self.editable.editing()){
        return self.columnWidthClass() + ' is-editing';
      } else {
        return self.columnWidthClass();
      }
    }, this);
  }
}
